/**
 * Transforma um valor monetário (Real brasileiro) em numeral.
 *
 * @category Currency
 *
 * @example
 * ```ts
 * import { brlToNumeral } from '@ids/tools';
 *
 * brlToNumeral('R$ 80,25')
 * // "80.25"
 * ```
 */
export const brlToNumeral = (value = 'R$ 0,00'): number =>
  Number(value.replace('R$', '').trim().replace('.', '').replace(',', '.')) || 0;
